



















import Vue from 'vue';
import Component from 'vue-class-component';
import Plyr from 'plyr';
import { Prop } from 'vue-property-decorator';

import { urlize } from '@/utils';

@Component
export default class PoiTextAudio extends Vue {

    public audioUrl = null;

    private audioToolbar: any;
    private audioTrack: HTMLAudioElement;
    private audioPlyr: Plyr;

    public mounted() {
        this.audioToolbar = this.$refs.audioToolbar as any;
        this.audioTrack = this.$refs.audioPlayer as HTMLAudioElement;
    }

    public beforeDestory() {
        this.stopAudio();
    }

    private plyrLazyInit() {
        if (!this.audioPlyr) {
            this.audioPlyr = new Plyr(this.audioTrack, {
                controls: ['play', 'progress', 'current-time'],
                tooltips: { controls: false, seek: false },
                invertTime: false
            });
        }
    }

    public playAudio(audioUrl: string) {
        this.audioUrl = audioUrl;
        this.plyrLazyInit();
        this.audioToolbar.show(true);
    }

    public stopAudio() {
        this.audioTrack.pause();
        this.audioToolbar.hide(true);
    }

    public onClose() {
        this.stopAudio();
    }
}
